// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/component/element/CarDamageForm/NewWageItemModal/NewWageItemModal.css
// module id = 1991
// module chunks = 0